import configData from "../../config.json";
import axios from "axios";

export const GetQuestion = async (v) => {
  var config = {
    method: "POST",
    url: configData.API_ENDPOINT + `option/get`,
    headers: {
      Authorization: "Bearer " + sessionStorage.getItem("token"),
      "Content-Type": "application/json",
    },
    data: v,
  };
  return axios(config)
    .then(function (response) {
      return response.data;
    })
    .catch(function (error) {
      return error;
    });
};

// To get questions for exam
export const GetExamQuestion = async (v) => {
  var config = {
    method: "POST",
    url: configData.API_ENDPOINT + `question/get`,
    headers: {
      Authorization: "Bearer " + sessionStorage.getItem("token"),
      "Content-Type": "application/json",
    },
    data: v,
  };
  return axios(config)
    .then(function (response) {
      return response.data;
    })
    .catch(function (error) {
      return error;
    });
};

//Exam submit
export const SubmitAnswers = async (payload) => {
  const config = {
    method: "POST",
    url: configData.API_ENDPOINT + `option`,
    headers: {
      Authorization: "Bearer " + sessionStorage.getItem("token"),
      "Content-Type": "application/json",
    },
    data: payload,
  };
  try {
    const response = await axios(config);
    return response.data;
  } catch (error) {
    if (error.response) {
      return {
        success: false,
        status: error.response.status,
        message: error.response.data || "Request failed",
      };
    } else {
      return {
        success: false,
        status: 0,
        message: error.message || "Network error",
      };
    }
  }
};

export const StartExam = async (v) => {
  var config = {
    method: "POST",
    url: configData.API_ENDPOINT + `exam`,
    headers: {
      Authorization: "Bearer " + sessionStorage.getItem("token"),
      "Content-Type": "application/json",
    },
    data: v,
  };
  return axios(config)
    .then(function (response) {
      return response.data;
    })
    .catch(function (error) {
      return error;
    });
};
